module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f0745d_banner_800x600.041ad0d6.png";